import * as React from 'react';

import { ErrorBoundary, ViewMedium, Viewport, ViewSmall } from 'bernie-view';

import { SearchPageName } from 'constants/pages';

import { UitkLayoutFlex } from 'uitk-react-layout-flex';

interface MesoInlineAdComponentProps {
  slotIndex: number;
  classNames?: string;
  key: string;
  pageId: string;
}
const mesoInlineAdConfig = {
  [SearchPageName.HC]: {
    slots: {
      7: {
        viewSmall: {
          id: 'CL3',
          uci: 'CL3',
        },
      },
      10: {
        viewSmall: {
          id: 'CL6',
          uci: 'CL6',
        },
      },
      13: {
        viewSmall: {
          id: 'CL9',
          uci: 'CL9',
        },
      },
    },
  },
  [SearchPageName.FH]: {
    slots: {
      7: {
        viewSmall: {
          id: 'CL3',
          uci: 'CL3',
        },
      },
      10: {
        viewSmall: {
          id: 'CL6',
          uci: 'CL6',
        },
      },
      13: {
        viewSmall: {
          id: 'CL9',
          uci: 'CL9',
        },
      },
    },
  },
  [SearchPageName.FHC]: {
    slots: {
      7: {
        viewSmall: {
          id: 'CL3',
          uci: 'CL3',
        },
      },
      10: {
        viewSmall: {
          id: 'CL6',
          uci: 'CL6',
        },
      },
      13: {
        viewSmall: {
          id: 'CL9',
          uci: 'CL9',
        },
      },
    },
  },
};

export const MesoInlineAdComponent: React.FunctionComponent<MesoInlineAdComponentProps> = props => {
  const { slotIndex, classNames, pageId } = props;
  const slot = mesoInlineAdConfig[pageId].slots[slotIndex];

  return (
    <>
      {
        <ErrorBoundary label="meso.display.ad">
          <Viewport>
            <ViewMedium />
            <ViewSmall>
              <UitkLayoutFlex className={`${classNames}`} justifyContent="center" tag="li">
                <meso-display-ad {...slot.viewSmall} />
              </UitkLayoutFlex>
            </ViewSmall>
          </Viewport>
        </ErrorBoundary>
      }
    </>
  );
};
MesoInlineAdComponent.displayName = 'MesoInlineAdComponent';

export const shouldMesoInlineAdRender = (pageName, slotIndex) =>
  pageName && mesoInlineAdConfig[pageName] && Object.keys(mesoInlineAdConfig[pageName].slots).indexOf(slotIndex.toString()) > -1;
